const pre = '/report/';

export default {
    path: '/report',
    title: '财务报表',
    header: '',
    icon: 'md-calculator',
    children: [
        // {
        //     path: `${pre}dcps`,
        //     title: '佰业维度'
        // },
        // {
        //     path: `${pre}user`,
        //     title: '用户维度'
        // },
        {
            path: `${pre}carbon`,
            title: '碳减排值 - 青岛'
        },
        {
            path: `${pre}carbon-sh`,
            title: '碳减排值 - 上海'
        },
        {
            path: `${pre}inventory`,
            title: '数据盘点 - 青岛'
        },
        {
            path: `${pre}inventory-sh`,
            title: '数据盘点 - 上海'
        },
    ]
}